import {
  Create_CONTACT
  } from "../type";
  const initialState = {
    Contact: [],
    loading: false,

  };
  const ContactR = (state = initialState, action) => {
    switch (action.type) {
      case Create_CONTACT:
        return {
          Contact: action.payload,
          loading: false,
        };
      default:
        return state;
    }
  };
  export default ContactR;
  